import axios from 'axios'
import { useState, useEffect } from 'react';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit, AiOutlinePlus } from 'react-icons/ai';
import ToastNotification from '../../components/ToastNotification';
import { CiEdit } from "react-icons/ci";
import Select from 'react-select';




const AccountMaster = () => {
    const [showForm, setShowForm] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);

    const [searchTerm, setSearchTerm] = useState('');
    const [schedule, setSchedule] = useState([]);

    const handleAddClick = () => {
        setShowForm(true);
    };

    const [form, setForm] = useState({
        type_acc: '',
        parent_name: '',
        short_name: '',
        balance_sheet: ''

    })
    const [accountType, setAccountType] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editingCompanyId, setEditingCompanyId] = useState(null);
    const [parent, setParent] = useState([]);
    const [sheet, setSheet] = useState([]);

    const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
    const showToast = (msg, bg = 'success') => {
        setToast({ show: true, message: msg, bg });
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();


        if (isEditMode) {
            const sendData = new FormData();

            sendData.append("type_acc", form.type_acc);
            sendData.append("parent_name", form.parent_name);
            sendData.append("short_name", form.short_name);
            sendData.append("balance_sheet", form.balance_sheet);



            try {
                const res = await axios.put(
                    `https://api.skyguard.group/api/update-master-account/${form.id}`,
                    sendData,
                    { headers: { "Content-Type": "application/json", } }
                );


                showToast('Account type updated successfully!', 'success');
                fecthDetail();
                setShowForm(false);
                setForm({
                    type_acc: '',
                    parent_name: '',
                    short_name: '',
                    balance_sheet: ''
                })
            } catch (err) {
                console.error("❌ Error:", err.response?.data || err.message);
                showToast('Fail to update Account type  !', 'danger');
            }
        } else {

            const duplicate = accountType.some(
                (item) =>
                    item.short_name && // skip items without short_name
                    item.short_name.toLowerCase().trim() === form.short_name.toLowerCase().trim()
            );
            if (duplicate) {
                showToast('Short name already exists!', 'warning');
                return; // stop submission
            }
            const sendData = new FormData();

            sendData.append("type_acc", form.type_acc);
            sendData.append("parent_name", form.parent_name);
            sendData.append("short_name", form.short_name);
            sendData.append("balance_sheet", form.balance_sheet);



            try {
                const res = await axios.post(
                    "https://api.skyguard.group/api/add-master-account",
                    sendData,
                    { headers: { "Content-Type": "application/json", } }
                );


                showToast('Account type Added successfully!', 'success');
                fecthDetail();
                setShowForm(false);
                setForm({
                    type_acc: '',
                    parent_name: '',
                    short_name: '',
                    balance_sheet: ''
                })
            } catch (err) {
                console.error("❌ Error:", err.response?.data || err.message);
                showToast('Fail to added Account type  !', 'danger');
            }

        };




    };


    const openModal = (id) => {
        setSelectedId(id);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedId(null);
    }


    const confirmDelete = () => {
        if (selectedId) {

        }
        closeModal();
    };

    const fecthDetail = async () => {

        try {
            const resParty = await axios.get('https://api.skyguard.group/api/fetch-acc-master');
            setAccountType(resParty.data.result);

            const uniqueParentNames = [...new Set(resParty.data.result.map(item => item.parent_name))];
            const uniqueBalanceSheets = [...new Set(resParty.data.result.map(item => item.balance_sheet))];
            setParent(uniqueParentNames);
            setSheet(uniqueBalanceSheets);
        } catch (error) {
            console.log(error)
        }
    };

    const fetchSchedule = async () => {
        try {
            const resParty = await axios.get('https://api.skyguard.group/api/fetch-schedule');
            setSchedule(resParty.data);
        } catch (error) {
            console.log(error)
        }
    };

    useEffect(() => {
        fetchSchedule();
        fecthDetail();
    }, []);



    const handleEdit = (form) => {

        setForm({
            id: form.id || '',
            type_acc: form.type_acc || '',
            parent_name: form.parent_name || '',
            short_name: form.short_name || '',
            balance_sheet: form.balance_sheet || ''
        });
        setEditingCompanyId(form.id);
        setIsEditMode(true);
        setShowForm(true);
    };


    const handleAddNewParent = () => {
        const newParent = prompt('Enter new issue type:');
        if (newParent && !parent.includes(newParent)) {
            setParent((prev) => [...prev, newParent]);
            setForm((prev) => ({
                ...prev,
                parent_name: newParent
            }));
        }
    };

    const handleAddNewBalance = () => {
        const newBalance = prompt('Enter new Balance Sheet:');
        if (newBalance && !parent.includes(newBalance)) {
            setSheet((prev) => [...prev, newBalance]);
            setForm((prev) => ({
                ...prev,
                balance_sheet: newBalance
            }));
        }
    };


    const filterAccount = accountType.filter((tt) => {
        const term = searchTerm.toLowerCase();

        return (
            (tt.type_acc && tt.type_acc.toLowerCase().includes(term)) ||
            (tt.parent_name && tt.parent_name.toString().toLowerCase().includes(term)) ||
            (tt.short_name && tt.short_name.toString().toLowerCase().includes(term)) ||
            (tt.balance_sheet && tt.balance_sheet.toString().toLowerCase().includes(term))
        );
    });


    const scheduleMap = Object.fromEntries(
        schedule.map(item => [item.id, item.schedule_name])
    );

    return (
        <>
            <div className='main-section'>
                <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                    <ToastNotification
                        show={toast.show}
                        message={toast.message}
                        bg={toast.bg}
                        onClose={() => setToast({ ...toast, show: false })}
                    />
                    <h3 className='my-3 fw-bold fs-5 golos'>Master of Account</h3>



                    <div className="mb-3 d-flex flex-wrap align-items-end justify-content-between">

                        <div className="mb-2 w-50 w-md-50 pe-md-2">
                            <input
                                className="form-control w-100"
                                list="datalistOptions"
                                placeholder="Search by Parent,Type ,Balance Sheet...."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>


                        <div className="mb-2">
                            <button className="btn btn-success" onClick={handleAddClick}>
                                <AiOutlinePlusCircle size={20} /> Add
                            </button>
                        </div>
                    </div>


                    {showForm && (


                        <div className='card p-3 mb-3  '>
                            <form onSubmit={handleSubmit} >

                                {isEditMode && (
                                    <div className="mb-3">
                                        {/* <label>Company  Name:</label> <br /> */}
                                        <span className="badge bg-primary px-3 py-2">
                                            {form.type_acc}
                                        </span>
                                    </div>
                                )}


                                <hr />

                                <div className='row g-3'>




                                    <div className="col-md-4">
                                        <label htmlFor='name' className="form-label fw-medium" > Account  Type</label>
                                        <input type="text" className="form-control" name="type_acc" placeholder="Enter here..." value={form.type_acc} onChange={handleInputChange} required />
                                    </div>


                                    <div className="col-md-4">
                                        <label htmlFor='name' className="form-label fw-medium " >Parent Account</label>

                                        <br />


                                        <select name='parent_name' value={form.parent_name} onChange={(e) => {
                                            if (e.target.value === 'add_new') {
                                                handleAddNewParent();
                                            } else {
                                                handleInputChange(e);
                                            }
                                        }} className='profile-input form-control' required>
                                            <option value=''>--- Select ---</option>
                                            {parent.map((i_type, index) => (
                                                <option key={index} value={i_type}>{i_type}</option>
                                            ))}
                                            <  option value='add_new'>+ Add New Parent</option>

                                        </select>

                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor='name' className="form-label fw-medium" >Short Name</label>
                                        <input type="text" className="form-control" name="short_name" placeholder="Enter here..." value={form.short_name} onChange={handleInputChange} required />
                                    </div>

                                    {/* <div className="col-md-4">
                                        <label htmlFor='name' className="form-label fw-medium" >Balance Sheet Schedule</label>

                                        <br />

                                        <select name='balance_sheet' value={form.balance_sheet} onChange={(e) => {
                                            if (e.target.value === 'add_new') {
                                                handleAddNewBalance();
                                            } else {
                                                handleInputChange(e);
                                            }
                                        }} className='profile-input form-control' required>
                                            <option value=''>--- Select ---</option>
                                            {sheet.map((i_type, index) => (
                                                <option key={index} value={i_type}>{i_type}</option>
                                            ))}
                                            <option value='add_new'>+ Add New Balance Sheet</option>
                                           
                                        </select>
                                    </div> */}

                                    <div className="col-md-4">

                                        <label className="form-label fw-medium">
                                            Balance Sheet Schedule
                                        </label>

                                        <select
                                            name="balance_sheet"
                                            value={form.balance_sheet}
                                            onChange={(e) => {
                                                if (e.target.value === 'add_new') {
                                                    handleAddNewBalance();
                                                } else {
                                                    handleInputChange(e);
                                                }
                                            }}
                                            className="profile-input form-control"
                                            required
                                        >

                                            <option value="">--- Select ---</option>

                                            {schedule.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.schedule_name}({item.type})
                                                </option>
                                            ))}



                                        </select>

                                    </div>


                                    <div className='gap-2 d-flex justify-content-start mt-4'>

                                        <button type="submit" className='btn btn-success w-10'>
                                            {isEditMode ? "Update" : "Save"}
                                        </button>
                                        <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                                            setShowForm(false);
                                            setIsEditMode(false);
                                            setForm({
                                                type_acc: '',
                                                parent_name: '',
                                                short_name: '',
                                                balance_sheet: ''
                                            })
                                        }}>
                                            Cancel
                                        </button>

                                    </div>

                                </div>
                            </form>
                        </div>
                    )}


                    {showModal && (
                        <div
                            className="modal fade show"
                            style={{
                                display: "block",
                                backgroundColor: "rgba(0,0,0,0.5)",
                            }}
                            tabIndex="-1"
                        >
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Confirm Delete</h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={closeModal}
                                        ></button>
                                    </div>
                                    <div className="modal-body">
                                        <p>
                                            Are you sure you want to delete this detail.
                                            <strong>{selectedId}</strong>?
                                        </p>
                                    </div>
                                    <div className="modal-footer">
                                        <button className="btn btn-secondary" onClick={closeModal}>
                                            Cancel
                                        </button>
                                        <button className="btn btn-danger" onClick={confirmDelete}>
                                            Delete
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}


                    <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                        <table className='table table-bordered table-striped table-hover text-center align-middle'>

                            <thead className='table-info'>
                                <tr>
                                    <th scope='col'>SN</th>
                                    <th scope='col'>Action</th>

                                    <th scope='col'> Account Type </th>
                                    <th scope='col'>Parent </th>
                                    <th scope='col' >Balance Sheet </th>


                                </tr>
                            </thead>
                            <tbody>
                                {filterAccount.map((acc, idx) => (
                                    <tr key={idx} >

                                        <td>{idx + 1}</td>
                                        <td>  <button
                                            className="btn btn-success"
                                            onClick={() => handleEdit(acc)}

                                        >
                                            < CiEdit size={20} />
                                        </button>
                                        </td>

                                        <td>
                                            {acc.type_acc}
                                        </td>
                                        <td> {acc.parent_name} </td>
                                        <td>
                                            {scheduleMap[acc.balance_sheet] || '-'}
                                        </td>


                                    </tr>


                                ))}
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>

        </>
    )
}

export default AccountMaster